import { render, staticRenderFns } from "./cDocumentDetails.vue?vue&type=template&id=17a83992&scoped=true"
import script from "./cDocumentDetails.vue?vue&type=script&lang=js"
export * from "./cDocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDetails.vue?vue&type=style&index=0&id=17a83992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a83992",
  null
  
)

export default component.exports